import {useNavigate} from 'react-router-dom';

import {removeCookie} from '../api/cookie';

const useLogout = () => {
    const navigate = useNavigate();
    
    const logout = () => {
        ['accessToken', 'username', 'administrator'].forEach((cookieName) => {
            removeCookie(cookieName, { path: '/' });
        });
        
        navigate('/auth/login');
    };
    
    return logout;
};

export default useLogout;
